/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = ./node_modules/@angular/cli/node_modules/webpack/buildin/amd-options.js
// module chunks = vendor